<template>
  <transition name="slidein">
  <div id="pullsheet" v-if="showing || lockshowing" class="pullsheet">
    <div class="singlesheet" v-if="state === 'singlesheet'">
      <h2>
        <a @click="manageSheets()" class="managesheets" v-if="user.loggedIn"><i class="material-icons">filter_none</i></a>
        <template v-if="!editName">
          <a @click="editName = true, newName = activePullSheet.name" class="editname"><i class="material-icons">mode_edit</i></a>
          {{activePullSheet.name}}
        </template>
        <template v-if="editName">
          <form class="rename" v-on:submit.prevent="renameSheet()">
            <input type="text" name="name" @focus="$event.target.select()" @blur="renameSheet()" ref="editnamefield" v-model="newName" maxlength="24" v-focus>
          </form>
        </template>
      </h2>
      <div class="panel-content thumbs" ref="thumbpanel">
        <div class="details" v-if="activePullSheet.items.length > 0">
            <div class="controls">
              <a @click="deleteAllPhotos" target="_blank"><i class="material-icons">delete</i> Delete All</a>
              <a v-bind:href="'https://api.therenees.com/pullsheet/pdf/' + activePullSheet.token" target="_blank"><i class="material-icons">insert_drive_file</i> Download .pdf</a>
              <a @click="showLink = !showLink"><i class="material-icons">link</i> Share Link</a>
              <div class="sharelink" v-if="showLink">
                <input type="text" @click="$event.target.select()" ref="linkinput" readonly :value="'https://www.therenees.com/pullsheet/'+activePullSheet.token">
                <a @click="showLink = false">Cancel</a> <a @click="copyToClipboard">Copy Link</a> <router-link :to="'/pullsheet/'+activePullSheet.token">Visit</router-link>
              </div>
            </div>
            <div class="photos">
              <template v-for="(photo, photoindex) in activePullSheet.items">
                <div class="photo">
                  <div class="imgwrapper"><img :src="'https://img.therenees.com/' + photo.url"></div>
                  <div class="bottom">
                    <a class="delete" @click="deletePhoto(photo.url, photoindex)"><i class="material-icons">delete</i></a>
                    <router-link :to="'/location/' + photo.reneeid">{{photo.reneeid}}</router-link>
                  </div>
                </div>{{' '}}
              </template>
              <div class="justifier"></div> <div class="justifier"></div> <div class="justifier"></div>
            </div>
        </div>

        <div class="emptypullsheet" v-if="activePullSheet.items.length === 0">
          <h4>Pullsheet Is Empty</h4>
          <p>To get started click the Add To Pullsheet button on any photo.</p>
        </div>
      </div>
    </div>

    <div class="managesheets" v-if="state === 'managesheets'">
      <h2>My Pullsheets</h2>
      <div class="panel-content">
        <div v-if="loading" class="loading">Loading...</div>
        <div v-if="!loading" class="pullsheets">
          <ul>
            <li v-for="pullsheet in allPullSheets" @click="setPullSheet(pullsheet)">
              <i class="material-icons button" @click.stop="copyPullSheet(pullsheet.token)">content_copy</i>
              <i class="material-icons button" @click.stop="deletePullSheet(pullsheet.token)">delete</i>
              {{pullsheet.name}}
              <small>{{pullsheet.items.length}} Photos<template v-if="pullsheet.timestamp">, Created {{pullsheet.timestamp}}</template></small>
            </li>
            <li class="new" @click="setPullSheet({token: false})"><i class="material-icons">add_box</i> New Pullsheet</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  </transition>
</template>

<script>
const focus = {
  inserted (el) {
    el.focus()
  }
}
export default {
  name: 'PullSheet',
  props: {
    showing: false
  },
  data () {
    return {
      state: 'singlesheet',
      user: this.$root.user,
      activePullSheet: this.$root.activePullSheet,
      itemToAdd: this.$root.itemToAdd,
      lockshowing: false,
      loading: true,
      allPullSheets: false,
      showLink: false,
      editName: false,
      newName: ''
    }
  },
  directives: {
    focus
  },
  methods: {
    showPullSheet: function () {
      this.$emit('showingPullSheet')
    },
    initializePullSheet: function () {
      if (this.activePullSheet.loaded) return
      if (this.$cookie.get('ps') !== null && this.$cookie.get('ps') !== 'false') {
        this.activePullSheet.token = this.$cookie.get('ps')
      }
      if (!this.activePullSheet.token && this.user.session) {
        // user has session cookie, query server to look for current pullsheet
        this.findPullSheet()
      }
      if (this.activePullSheet.token) {
        this.loadPullSheet(this.activePullSheet.token)
      }
    },
    destroyPullSheet: function () {
      this.$cookie.delete('ps', {domain: '.therenees.com'})
      this.activePullSheet.token = false
      this.activePullSheet.items.splice(0, this.activePullSheet.items.length)
      this.activePullSheet.loaded = false
      this.activePullSheet.name = 'Untitled Pullsheet'
    },
    lockDisplay: function () {
/*
      this.lockshowing = true
      setTimeout(() => {
        this.lockshowing = false
      }, 5000)
*/
    },
    addToPullSheet: function (plnumber, photo) {
      var inpullsheet = false
      this.activePullSheet.items.forEach(existingphoto => {
        if (existingphoto.url === photo) inpullsheet = true
      })
      if (inpullsheet) return

      this.$http.get(this.$root.apiurl + 'pullsheet/add', {
        params: {
          plno: plnumber,
          photo: photo,
          pullsheetid: this.activePullSheet.token}
      }).then(response => {
        if (response.body.utoken.substr(0, 5) === 'anon-') {
          this.$cookie.set('pla', response.body.utoken, {expires: 365, domain: '.therenees.com'})
        }
        if (response.body.isnew) {
          this.activePullSheet.name = response.body.name
        }
        this.$cookie.set('ps', response.body.pullsheetid, {expires: 365, domain: '.therenees.com'})
        this.activePullSheet.token = response.body.pullsheetid
        var photopl = this.$root.getPLByNumber(plnumber)
        if (!inpullsheet) this.activePullSheet.items.push({plno: plnumber, url: photo, reneeid: photopl.reneeid})
        this.$emit('itemAdded')
        this.$root.logActivity('Added PL' + plnumber + ' to pullsheet ' + this.activePullSheet.name)
      }, response => {
        console.log(response.statusText)
      })
    },
    loadPullSheet: function (pullsheetid) {
      this.$http.get(this.$root.apiurl + 'pullsheet/load', {
        params: {
          pullsheetid: pullsheetid
        }
      }).then(response => {
        if (!response.body.success) return
        this.$cookie.set('ps', response.body.pullsheetid, {expires: 365, domain: '.therenees.com'})
        this.activePullSheet.token = response.body.pullsheetid
        this.activePullSheet.name = response.body.pullsheet.name
        console.log('loading', response.body.pullsheet.items)
        response.body.pullsheet.items.forEach(photo => {
          var photopl = this.$root.getPLByNumber(photo.plno)
          photo.reneeid = photopl.reneeid
          this.activePullSheet.items.push(photo)
        })
        this.activePullSheet.loaded = true
      }, response => {
        console.log(response.statusText)
      })
    },
    findPullSheet: function () {
      this.$http.get(this.$root.apiurl + 'pullsheet/list').then(response => {
        if (response.body.success) {
          this.loadPullSheet(response.body.pullsheets[0].token)
        }
        this.activePullSheet.loaded = true
      }, response => {
        console.log(response.statusText)
      })
    },
    deletePhoto: function (url, photoindex) {
      this.$http.get(this.$root.apiurl + 'pullsheet/remove', {
        params: {
          pullsheetid: this.activePullSheet.token,
          photo: url
        }
      }).then(response => {
        if (!response.body.success) return
        this.activePullSheet.items.splice(photoindex, 1)
        this.$root.logActivity('Removed photo ' + url + ' from pullsheet')
      }, response => {
        console.log(response.statusText)
      })
    },
    deleteAllPhotos: function () {
      if (confirm('Are you sure you want to delete all photos in this pullsheet?')) {
        this.$http.get(this.$root.apiurl + 'pullsheet/removeall', {
          params: {
            pullsheetid: this.activePullSheet.token
          }
        }).then(response => {
          if (!response.body.success) return
          this.activePullSheet.items = []
          this.$root.logActivity('Removed all photos from pullsheet')
        }, response => {
          console.log(response.statusText)
        })
      }
    },
    renameSheet: function () {
      if (this.newName === '') {
        this.editName = false
        return
      }
      this.$http.get(this.$root.apiurl + 'pullsheet/rename', {
        params: {
          pullsheetid: this.activePullSheet.token,
          name: this.newName
        }
      }).then(response => {
        if (!response.body.success) return
        if (response.body.utoken.substr(0, 5) === 'anon-') {
          this.$cookie.set('pla', response.body.utoken, {expires: 365, domain: '.therenees.com'})
        }
        this.activePullSheet.name = this.newName
        this.editName = false
        this.$cookie.set('ps', response.body.pullsheetid, {expires: 365, domain: '.therenees.com'})
        this.activePullSheet.token = response.body.pullsheetid

        this.$root.logActivity('Renamed pullsheet to ' + this.activePullSheet.name)
      }, response => {
        console.log(response.statusText)
      })
    },
    manageSheets: function () {
      this.loading = true
      this.state = 'managesheets'
      this.$http.get(this.$root.apiurl + 'pullsheet/list').then(response => {
        if (response.body.success) {
          this.allPullSheets = response.body.pullsheets
        } else {
          this.allPullSheets = [{
            token: false,
            name: 'Untitled Pullsheet',
            items: [],
            timestamp: false
          }]
        }
        this.loading = false
      }, response => {
        console.log(response.statusText)
      })
    },
    setPullSheet: function (pullsheet) {
      this.destroyPullSheet()
      if (pullsheet.token) {
        this.$cookie.set('ps', pullsheet.token, {expires: 365, domain: '.therenees.com'})
        this.activePullSheet.token = pullsheet.token
        this.activePullSheet.name = pullsheet.name
        this.activePullSheet.loaded = true
        pullsheet.items.forEach(photo => {
          var photopl = this.$root.getPLByNumber(photo.plno)
          photo.reneeid = photopl.reneeid
          this.activePullSheet.items.push(photo)
        })
        this.activePullSheet.loaded = true
      } else {
        this.activePullSheet.token = 'new'
        this.$cookie.set('ps', 'new', {expires: 365, domain: '.therenees.com'})
      }
      this.state = 'singlesheet'
    },
    deletePullSheet: function (pullsheetid) {
      this.$http.get(this.$root.apiurl + 'pullsheet/deletesheet', {
        params: {
          pullsheetid: pullsheetid
        }
      }).then(response => {
        if (!response.body.success) return
        this.manageSheets()
        this.$root.logActivity('Deleted pullsheet ' + pullsheetid)
      }, response => {
        console.log(response.statusText)
      })
    },
    copyPullSheet: function (pullsheetid) {
      this.$http.get(this.$root.apiurl + 'pullsheet/copy', {
        params: {
          pullsheetid: this.activePullSheet.token
        }
      }).then(response => {
        if (!response.body.success) return
        this.manageSheets()
        this.$root.logActivity('Duplicated pullsheet ' + pullsheetid)
      }, response => {
        console.log(response.statusText)
      })
    },
    copyToClipboard: function () {
      this.$refs.linkinput.click()
      document.execCommand('Copy')
    }
  },
  watch: {
    'itemToAdd': {
      handler: function (val, oldVal) {
        if (val.trigger) {
          this.addToPullSheet(val.plno, val.url)
          this.itemToAdd.trigger = false
          this.itemToAdd.plno = false
          this.itemToAdd.url = false
        }
      },
      deep: true
    },
    'user': {
      handler: function (val, oldVal) {
        if (!val.loggedIn) {
          this.destroyPullSheet()
        } else {
          this.initializePullSheet()
        }
      },
      deep: true
    }
  },
  created: function () {
    this.initializePullSheet()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/_mixins.scss";
#pullsheet {
  z-index: 100;
  position: fixed;
  background: #FFF;
  text-align: right;
  box-sizing: border-box;
  padding: 1.25em;
  border: 1px solid #DCDCDC;
  box-shadow: 1px 1px 24px rgba(0,0,0,.06);
  top: 71px;
  right: 2%;
  width: 96%;
  @include bp(most) {
    top: 104px;
    right: 55px;
    width: 393px;
  }
    &:before {
      content: "";
      position: absolute;
      top: -15px;
      border-width: 0 15px 15px;
      border-style: solid;
      border-color: #DCDCDC transparent;
      display: block;
      width: 0;
      right: 2px;
      @include bp(most) {
        right: 30px;
      }
    }
    &:after {
      content: "";
      position: absolute;
      top: -14px;
      border-width: 0 14px 14px 14px;
      border-style: solid;
      border-color: #fff transparent;
      display: block;
      width: 0;
      right: 3px;
      @include bp(most) {
        right: 31px;
      }
    }
    &.floating {
      @include bp(most) {
        position: absolute;
        top: 79px;
        right: calc(5% + 24px);
      }
    }
}

h2 {
  font-size: 1.75em;
  font-weight: 300;
  color: #8A8A8A;
  border-bottom: 1px solid #CECECE;
  margin: 0px;
  line-height: 1.4;
  padding: 0 0 .25em 0;
  cursor: default;
  a {
    color: $notblack;
    display: inline-block;
    vertical-align: top;
    cursor: pointer;
    @include noselect();
    i {
      font-size: .75em;
    }
    &.managesheets {
      float: left;
      margin: 4px 0 0 8px;
    }
    &.editname {
      visibility: hidden;
    }
  }
  &:hover a.editname {
    visibility: visible;
  }
}

.rename {
  input {
    background: none;
    outline: none;
    border: 0px none;
    font-family: $montserrat;
    font-size: 1em;
    font-weight: 300;
    color: #8A8A8A;
    text-align: right;
    width: 90%;
  }
}

.panel-content {
  overflow-y: auto;
  max-height: calc(78vh - 80px);
  @include bp(most) {
    max-height: calc(85vh - 80px);
    &.thumbs {
      display: flex;
      flex-direction: column-reverse;
      max-height: calc(55vh - 80px);
    }
  }
}

.controls {
  padding: 1em .5em 1.25em;
  font-size: 12px;
  a {
    color: $blue;
    font-weight: 500;
    cursor: pointer;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
    i {
      vertical-align: bottom;
      font-size: 16px;
      color: $notblack;
      margin-left: 1em;
    }
  }
  .sharelink {
    padding: .5em 0;
    input {
      border: 0px none;
      outline: none;
      background: none;
      font-size: 10px;
      font-family: $noto;
      width: 100%;
      text-align: right;
    }
    a {
      font-size: 12px;
      color: $blue;
      cursor: pointer;
      display: inline-block;
      margin: .25em 0 0 .75em;
    }
  }
}
.photos {
  text-align: justify;
  font-size: 0px;
/*   margin-bottom: -1em; */
  .photo {
    font-size: 14px;
    width: 31%;
    display: inline-block;
    margin-bottom: 1em;
    .imgwrapper {
      overflow: hidden;
      max-height: 75px;
    }
    img {
      max-width: 100%;
    }
    a {
      color: #696969;
      text-decoration: none;
      font-size: 12px;
      &:hover {
        text-decoration: underline;
      }
    }
    a.delete {
      float: right;
      margin-top: 1px;
      visibility: hidden;
      cursor: pointer;
      color: $notblack;
      &:hover {
        color: $blue;
        text-decoration: none;
      }
      i {
        font-size: 14px;
      }
    }
    &:hover {
      a.delete {
        visibility: visible;
      }
    }
  }
  .justifier {
    width: 30%;
    display: inline-block;
    height: 1px;
  }
}

.loading {
  padding: 3em 1em;
  color: #8a8a8a;
  text-align: center;
  font-weight: 300;
  letter-spacing: .05em;
}

.pullsheets {
  padding-top: .75em;
  ul {
    list-style-type: none;
    margin: 0px;
    padding: 0px;
    li {
      font-size: 18px;
      padding: 1em;
      line-height: 1;
      font-weight: 300;
      cursor: pointer;
      small {
        display: block;
        color: #8a8a8a;
        font-size: 12px;
        padding: .25em 0 0;
      }
      &:hover {
        background: $yellow;
        i.button {
          visibility: visible;
        }
      }
      i {
        font-size: 1.25em;
        vertical-align: middle;
        &.button {
          float: left;
          visibility: hidden;
          margin-top: 6px;
          &:hover {
            color: $blue;
          }
        }
      }
      &.new {
        text-align: center;
        border: 1px solid $notblack;
        border-radius: 3px;
        padding: .75em 1em;
        margin-top: .5em;
        i {
          display: inline-block;
          float: none;
        }
      }
    }
  }
}



</style>



// WEBPACK FOOTER //
// PullSheet.vue?0550c32e